import { initiateZohoDesk, isZohoDeskAvailable } from "@/utils/zohoDesk";
import { useEffect } from "react";

export const useZohoDesk = () => {
    useEffect(() => {
        let count = 0;
        let done = false;
        const interval = setInterval(() => {
            count++;
            if (done || count > 10000) {
                clearInterval(interval);
                return;
            }
            if (isZohoDeskAvailable()) {
                done = true;
                clearInterval(interval);
                window.ZohoDeskAsapReady?.(function () {
                    initiateZohoDesk();
                });
            }
        }, 50);
    }, []);
};
